import { ISgSdkHandler, TriggerAction } from "./types";

declare const sdkHandler: ISgSdkHandler; 

export function showInterstitial() {
  return new Promise<void>(resolve => {
    sdkHandler.trigger(TriggerAction.BEFORE_PLAY_BUTTON_DISPLAY, {
      callback() {
        resolve();
      },
    });
  });
}